"use strict";
exports.__esModule = true;
var DimensionValueState_1 = require("./DimensionValueState");
var ChartDimensionState = /** @class */ (function () {
    function ChartDimensionState(_a) {
        var breakdown = _a.breakdown, filter = _a.filter;
        var _this = this;
        this.toJSON = function () { return ({
            breakdown: _this.breakdown,
            filter: _this.filter
        }); };
        this.isEqual = function (dimensionState) {
            if (dimensionState.breakdown.value !== _this.breakdown.value ||
                dimensionState.breakdown.isSelected !== _this.breakdown.isSelected) {
                return false;
            }
            if (dimensionState.filter.some(function (item, index) { return item.value !== _this.filter[index].value; })) {
                return false;
            }
            if (dimensionState.filter.some(function (item, index) { return item.isSelected !== _this.filter[index].isSelected; })) {
                return false;
            }
            return true;
        };
        this.breakdown = breakdown;
        this.filter = filter;
    }
    ChartDimensionState.fromJSON = function (json) {
        var _a = Object.assign({}, json), breakdown = _a.breakdown, filter = _a.filter;
        if (!Array.isArray(filter))
            throw new Error('.filter must be an array');
        var _filter = filter.map(function (value) {
            return DimensionValueState_1["default"].fromJSON(value);
        });
        return new ChartDimensionState({
            breakdown: breakdown,
            filter: _filter
        });
    };
    return ChartDimensionState;
}());
exports["default"] = ChartDimensionState;
